// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPatientsInStore,
  selectPatientsPageLoading,
  selectPatientsShowInitWaitingMessage,
} from '../_selectors/patient.selectors';

export class PatientsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPatientsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPatientsShowInitWaitingMessage));

    this.store.pipe(select(selectPatientsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
